module.exports = __webpack_public_path__ + "img/linkedin.7aae5309.svg";